// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__F8GwR","tooltipArrow":"styles_tooltipArrow__K1ysA"};